/**
 * Collapse alias to canonical value (case-insensitive).
 * Pass through non-strings and unknown strings unchanged.
 * Useful for Zod enum preprocessing.
 */
export const alias =
  (aliases: Record<string, string>) =>
  (value: unknown): unknown => {
    if (typeof value !== "string") return value;
    return aliases[value.trim().toLowerCase()] ?? value;
  };
